var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecureSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.55273,42.04736a9.55174,9.55174,0,1,0-.55712,14.00885l6.47412,6.47406,1.06054-1.06054-6.47412-6.47412A9.556,9.556,0,0,0,45.55273,42.04736ZM44.49219,54.49219a8.05005,8.05005,0,1,1,0-11.38428A8.05959,8.05959,0,0,1,44.49219,54.49219Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,9.25A16.76884,16.76884,0,0,0,23.25,26v7.25H16a.7502.7502,0,0,0-.75.75V68.3335a.7502.7502,0,0,0,.75.75H64a.7502.7502,0,0,0,.75-.75V34a.7502.7502,0,0,0-.75-.75H56.75V26A16.76884,16.76884,0,0,0,40,9.25ZM24.75,26a15.25,15.25,0,0,1,30.5,0v7.25H24.75Zm38.5,8.75V67.5835H16.75V34.75h46.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecureSearch);
export default __webpack_public_path__ + "static/media/icon_secure_search.daedb3f1c373eb4a17ad0ecf96c1b645.svg";
export { ForwardRef as ReactComponent };